// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__muqQo","alertIcon":"ConfirmModal_alertIcon__3aDrc"};